<template>
    <div class="infos">
        <ul>
            <li>
                <div class="infos-wrap">
                    <h5>{{'w.event-infos.date-label'|t}}</h5>

                    <div class="infos-values infos-values--date">
                        <p class="date">
                            <template v-if="event.start_date == event.end_date">
                                {{ event.start_date | formatDateEvent }}
                            </template>
                            <template v-else>
                                <span>{{ $t('w.event-infos.from') }}</span>
                                <span>{{ event.start_date | formatDateEvent }}</span>
                                <span>{{ $t('w.event-infos.to') }}</span>
                                <span>{{ event.end_date | formatDateEvent }}</span>
                            </template>
                        </p>

                        <p class="duration">
                            <span>{{ event.from | formatTimeEvent }}</span>
                            <span class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="5.447" height="9.48" viewBox="0 0 5.447 9.48">
                                     <path id="Tracé_1" data-name="Tracé 1" d="M428.9,772l4.386,4.387-4.386,4.386" transform="translate(-428.547 -771.646)" fill="none" stroke="#03f462" stroke-width="1"/>
                                </svg>
                            </span>
                            <span>{{ event.to | formatTimeEvent }}</span>
                            <simple-svg class="clock" :filepath="'/storage/img/icon/icon-clock.svg'" />
                            <span>{{ event.duration }} {{ 'w.event-infos.hours'|t }}</span>
                        </p>
                    </div>
                </div>
            </li>
            <li v-if="event.show_price">
                <div class="infos-wrap">
                    <h5>{{'w.event-infos.fees'|t}}</h5>
                    
                    <div class="infos-values">
                        <p v-if="event.price">
                        <span>{{ event.price }}€</span>
                        <span>{{'w.event-infos.per-ticket'|t}}</span>
                        </p>
                        <p v-else-if="! event.price">
                            {{'w.event-infos.event-free'|t}}
                        </p>
                    </div>
                </div>
            </li>
            <li>
                <div class="infos-wrap">
                    <h5>{{'w.event-infos.level'|t}}</h5>

                    <div class="infos-values">
                        <p>{{ $i18n.locale == 'fr' ? event.level.name : event.level.name_en }}</p>
                    </div>
                </div>
            </li>
            <li v-if="event.speakers.length">
                <div class="infos-wrap">
                    <h5>{{'w.event-infos.hosts'|t}}</h5>

                    <div class="infos-values">
                        <p v-for="speaker in event.speakers" :key="speaker.id">
                            <a :href="'#speaker-' + speaker.id" 
                                class="btn-link btn-link--small" 
                                @click.prevent="scrollTo('speaker-' + speaker.id)">
                                {{ speaker.name }}
                            </a>
                        </p>
                    </div>
                </div>
            </li>
            <li v-if="event.places">
                <div class="infos-wrap">
                    <h5>{{'w.event-infos.place'|t}}</h5>

                    <div class="infos-values">
                        <p class="mb-1">
                            <template v-if="event.places.website">
                                <a :href="event.places.website" target="_blank">
                                    {{ event.places.name }}
                                </a>
                            </template>
                            <template v-else>
                                {{ event.places.name }}
                            </template>
                        </p>
                        <div class="mb-1" v-html="event.places.address"></div>
                        <p v-if="event.places.maps">
                            <a :href="event.places.maps" target="_blank" class="btn-link btn-link--small event-place-link">
                                <simple-svg :filepath="'/storage/img/icon/icon-place.svg'" />
                                <span>{{'w.event-infos.get-there'|t}}</span>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                                        <path id="Tracé_14" data-name="Tracé 14" d="M10.985,7.7,6.689,12l-.706-.706,4.3-4.3H6.492V6h5.49v5.49h-1Z" transform="translate(-5.983 -6)" fill="#acd3ae" opacity="0.5"/>
                                    </svg>
                                </span>
                            </a>
                        </p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    methods: {
        scrollTo(id) {
            animateScrollTo(document.querySelector('.' + id), {
                offset: -100,
                passive: true
            });
        }
    }
}
</script>
